import React, { useContext } from "react";
import { DesignAssetContext } from "../../pages/CustomHooks/ContextApi";

const Busbar = (secondBusbar) => {
  const {
   count
  } = useContext(DesignAssetContext);
  const getX2ByDerCount = () => {
     let widthPerDer = 400;
     if (count?.derCount === 2 ) {
       widthPerDer = 315;
     }else if(count?.derCount === 3){
      widthPerDer = widthPerDer;
     }else if(count?.derCount === 4){
      widthPerDer += 120;
     }else if(count?.derCount === 5){
      widthPerDer += 240;
     }
      return widthPerDer;
  };
  return (
    <>
      { (
        <svg>
          <g id="busbar" >
            <line
              x1={count?.derCount === 2?70:100}
              y1={210}
              x2={getX2ByDerCount()}
              y2={210}
              stroke="var(--se-sld-circline)"
              strokeWidth="3"
            />
          </g>
        </svg>
      )}
    </>
  );
};

export default Busbar;
